export default __webpack_public_path__ + "static/media/contactsRed.4953be02.svg";